window.addEventListener('DOMContentLoaded', function() {
    let isMobileLayout = false; // Flag to track mobile layout state

    // Function to check if we are on mobile (max-width: 768px)
    function isMobile() {
        return window.innerWidth <= 768;
    }

    // Reorder cards on mobile based on their data-id
    function reorderCardsOnMobile() {
        if (isMobile() && !isMobileLayout) {
            isMobileLayout = true; // Set the flag to indicate mobile layout is active

            // Get both columns
            const leftColumn = document.querySelector('.gallery--desktop .col-md-6:first-child');
            const rightColumn = document.querySelector('.gallery--desktop .col-md-6:nth-child(2)');

            // Get all the card elements from both columns
            const leftCards = leftColumn ? Array.from(leftColumn.querySelectorAll('.card')) : [];
            const rightCards = rightColumn ? Array.from(rightColumn.querySelectorAll('.card')) : [];

            // Merge both arrays of cards
            const allCards = leftCards.concat(rightCards);

            // Sort the cards by their data-id attribute
            allCards.sort((a, b) => {
                const idA = a.getAttribute('data-id'); // Get data-id of card A
                const idB = b.getAttribute('data-id'); // Get data-id of card B
                return idA - idB; // Sort in ascending order
            });

            // Create a new container for all cards and append them in the desired order
            const mobileColumn = document.createElement('div');
            mobileColumn.classList.add('col'); // Single column layout for mobile

            allCards.forEach(card => {
                mobileColumn.appendChild(card);
            });

            // Remove existing columns and append the new column with the reordered cards
            if (leftColumn) leftColumn.parentNode.removeChild(leftColumn);
            if (rightColumn) rightColumn.parentNode.removeChild(rightColumn);

            // Add the new column into the gallery container
            const galleryContainer = document.querySelector('.gallery--desktop');
            galleryContainer.appendChild(mobileColumn);
        }
    }

    // Reinstate columns on desktop based on data-id (odd for column 1, even for column 2)
    function reinstateColumnsOnDesktop() {
        if (!isMobile() && isMobileLayout) {
            isMobileLayout = false; // Reset the flag to indicate desktop layout

            // Get all the cards currently in the single column layout
            const mobileColumn = document.querySelector('.gallery--desktop .col');

            if (mobileColumn) {
                const allCards = Array.from(mobileColumn.querySelectorAll('.card'));

                // Sort the cards by their data-id attribute
                allCards.sort((a, b) => {
                    const idA = a.getAttribute('data-id');
                    const idB = b.getAttribute('data-id');
                    return idA - idB;
                });

                // Create two new columns for desktop
                const column1 = document.createElement('div');
                const column2 = document.createElement('div');
                column1.classList.add('col-12', 'col-md-6', 'd-flex', 'flex-column');
                column2.classList.add('col-12', 'col-md-6', 'd-flex', 'flex-column', 'col-right');

                // Distribute the cards into the two columns based on their data-id (odd and even)
                allCards.forEach((card, index) => {
                    if (index % 2 === 0) {
                        column1.appendChild(card); // Odd index goes into column 1
                    } else {
                        column2.appendChild(card); // Even index goes into column 2
                    }
                });

                // Remove the current mobile column
                mobileColumn.parentNode.removeChild(mobileColumn);

                // Add the two columns into the gallery container
                const galleryContainer = document.querySelector('.gallery--desktop');
                galleryContainer.appendChild(column1);
                galleryContainer.appendChild(column2);
            }
        }
    }

    // Call the appropriate function on page load and on window resize
    reorderCardsOnMobile();
    let mobileCardsViewed = false;

    window.addEventListener('resize', function() {
        if (isMobile()) {
            mobileCardsViewed = true;
            reorderCardsOnMobile(); // Reorder cards for mobile only if it's not already in mobile layout
        } else {
            if ( mobileCardsViewed ) {
                mobileCardsViewed = false;
                ConfigureFlipCards();
            }
            reinstateColumnsOnDesktop(); // Reinstate columns for desktop if it's not already in desktop layout
        }
    });

    //add listener for all cards
    const cards = document.querySelectorAll('.flip-cards-desktop .flip-card');
    
    let detectedTouchInput = false; 

    document.addEventListener('touchstart', function(event) {
        detectedTouchInput = true;

        if ( !event.target.classList.contains('is-touch-flipped') ) {
            RemoveTouchFlip(event);
        }
    });
        
    function RemoveTouchFlip(event) {
        let touchcard = document.querySelector('.flip-cards-desktop .is-touch-flipped');
        
        if ( !touchcard ) return;
        
        if ( touchcard.contains(event.target) ) return;

        touchcard.classList.remove('is-touch-flipped', 'flip-in');
        touchcard.classList.add('flip-out');

        setTimeout(function() {
            touchcard.classList.remove('flip-out');
        }, transition);
    }
    
    ConfigureFlipCards();
        

    function UpdateCardHeight(card) {
        // get child element flip-card__back 
        const cardBack = card.querySelector('.flip-card__face');
        const cardBackBody = card.querySelector('.flip-card__back .card-body');

        // set inline height on card
        cardBack.style.height = cardBackBody.offsetHeight + 'px';
        card.style.height = cardBackBody.offsetHeight + 'px';
    }

    function ConfigureFlipCards() {
        if ( cards.length ) {
            cards.forEach(card => {
                transition = 300;
    
                UpdateCardHeight(card);
                
                card.addEventListener('pointerdown', function(event) {
                    if ( detectedTouchInput || event.pointerType === "touch" ) {

                        if (event.target.tagName.toLowerCase() === "a") {
                            return;
                        }

                        if ( card.classList.contains('is-touch-flipped') ) {
                            card.classList.remove('is-touch-flipped', 'flip-in');
                            card.classList.add('flip-out');

                            setTimeout(function() {
                                card.classList.remove('flip-out');
                            }, transition);
                        } else {
                            RemoveTouchFlip(event);
                            card.classList.add('is-touch-flipped', 'flip-in');

                            setTimeout(function() {
                                card.classList.remove('flip-in');
                            }, transition);
                        }
                    }
                });
                
                function flipIn() {
                    card.classList.add('is-flipped', 'flip-in');
    
                    setTimeout(function() {
                        card.classList.remove('flip-in');
                    }, transition);
                }
        
                function flipOut() {
                    card.classList.remove('is-flipped', 'flip-in');
                    card.classList.add('flip-out');
    
                    setTimeout(function() {
                        card.classList.remove('flip-out');
                    }, transition);
                }
                
                card.addEventListener('pointerenter', function(event) {
                    if ( detectedTouchInput || event.pointerType === "touch" ) return;
                    flipIn();
                });

                card.addEventListener('pointerleave', function(event) {
                    if ( detectedTouchInput || event.pointerType === "touch" ) return;
                    flipOut();
                });
            });
        }
    }
    

    //add listener for all cards
    const swiperCards = document.querySelectorAll('.swiper .flip-card');

    if ( swiperCards.length ) {

        swiperCards.forEach(card => {
            card.addEventListener('click', function(event) {
                // allows clicking of anchor links
                if (event.target.tagName.toLowerCase() === "a" || event.target.closest("a")) {
                    return;
                }

                if ( card.classList.contains('is-touch-flipped') ) {
                    card.classList.remove('is-touch-flipped');
                } else {
                    card.classList.add('is-touch-flipped');
                }
            });
        });
    };

    const flipCards = new Swiper('.flip-cards-swiper', {
        navigation: {
            nextEl: ".flip-cards-next",
            prevEl: ".flip-cards-prev",
        },
        height: 800,
        centerSlides: true,
        slidesPerView: 1,
        paginationClickable: true,
        loop: true,
        preventClicks: true,
        preventClicksPropagation: false,
        noSwipingSelector: 'a',
    });

});

window.addEventListener("load", function() {
    let updateCards = document.querySelectorAll('.flip-cards-desktop .flip-card');
    
    updateCards.forEach(card => {
        UpdateCardHeight(card);
    });

    function UpdateCardHeight(card) {
        // get child element flip-card__back 
        const cardBack = card.querySelector('.flip-card__face');
        const cardBackBody = card.querySelector('.flip-card__back .card-body');

        // set inline height on card
        cardBack.style.height = cardBackBody.offsetHeight + 'px';
        card.style.height = cardBackBody.offsetHeight + 'px';
    }
});
